import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { checkoutStepDefinition } from "../CheckoutPage/CheckoutStartup";
import { OnHoldBookingInitStepDeclaration } from "./Steps/OnHoldBookingInitStep";
import { OnHoldBookingTransition } from "./Transition/OnHoldBookingTransition";

export const onHoldBookingStartupFlow = new FlowDefinition("OnHoldBookingFlow");

onHoldBookingStartupFlow.addStep(OnHoldBookingInitStepDeclaration);
onHoldBookingStartupFlow.addStep(checkoutStepDefinition);

onHoldBookingStartupFlow.addLink("OnHoldBookingInit_Step", "CheckoutFlow")

onHoldBookingStartupFlow.addTransition(OnHoldBookingTransition, "OnHoldBookingInit_Step")

onHoldBookingStartupFlow.setStartStep("OnHoldBookingInit_Step");

export const onHoldBookingStartupStepDefinition = new StepDefinition({
    stepName: "OnHoldBookingFlow",
    stepFlow: onHoldBookingStartupFlow,
    contextIsolation: false
})
